<template>
   <div class="inline">
     <div class="flex items-center">
       <div class="progress mr-2" v-on:mouseover="hover" v-on:mouseout="hoverOut">
         <div class="progressbarval text-center z-50" :style="{width: totalProgress + '%', background: setColor }" ></div>
        </div>
        <div>{{totalProgress}}%</div>
       </div>
      <div class="user-popover rounded-lg ml-6 p-3 px-4 relative" v-if="showPopup" transition="fade" v-on:mouseover="hoverInfo" v-on:mouseout="hoverOutInfo">
        <div class="w-full">
          <p class="text-left text-xs align-top mb-4">Display Elements</p>
        </div>
        <div class="flex flex-col">
          <div class="mb-2 border-b" v-for="(personalDetail, name) in personal_details" :key="name">
            <div class="flex flex-row justify-between mb-1">
                <div class="w-36"><p class="text-xs text-left">{{personal_details[name].name}}</p></div>
                <div v-if="personal_details[name].complete" class=""><i class="ml-2 fas fa-check-circle text-green"></i></div>
                <div v-else class=""><i class="ml-2 fas fa-times-circle text-red"></i></div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: [
    'popUpUser'
  ],
  created () {
    this.calculateProgressBar()
    this.setProgressBarColor()
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  data () {
    return {
      showPopup: false,
      timer: '',
      isInInfo: false,
      totalProgress: 0,
      setColor: '',
      personal_details: {
        PersonalDetails: {
          name: 'Personal Details',
          complete: false
        },
        ProfilePictureVideo: {
          name: 'Profile Picture/video',
          complete: false
        },
        SocialMedia: {
          name: 'Social Media',
          complete: false
        },
        WebBiography: {
          name: 'Web Biography',
          complete: false
        },
        SalesParticulatebio: {
          name: 'Sales Particulars bio',
          complete: false
        }
      }
    }
  },
  methods: {
    calculateProgressBar () {
      let personalDetailspercentage = 40 / 6
      let completedPersonalDetails = 0
      if (this.popUpUser.name) {
        completedPersonalDetails = completedPersonalDetails + personalDetailspercentage
      }
      if (this.popUpUser.email) {
        completedPersonalDetails = completedPersonalDetails + personalDetailspercentage
      }
      if (this.popUpUser.phone) {
        completedPersonalDetails = completedPersonalDetails + personalDetailspercentage
      }
      if (this.popUpUser.position) {
        completedPersonalDetails = completedPersonalDetails + personalDetailspercentage
      }
      if (this.popUpUser.whatsapp_account) {
        completedPersonalDetails = completedPersonalDetails + personalDetailspercentage
      }
      if (this.popUpUser.facebook_messenger) {
        completedPersonalDetails = completedPersonalDetails + personalDetailspercentage
      }

      let photoVideoPercentage = 10
      let completedPhotoVideo = 0
      if (this.popUpUser.uploaded_photo) {
        completedPhotoVideo = completedPhotoVideo + photoVideoPercentage
      }
      if (this.popUpUser.uploaded_video) {
        completedPhotoVideo = completedPhotoVideo + photoVideoPercentage
      }

      var socialMediaLinks = this.popUpUser.social_media
      let socialMediaPercentage = 20 / Object.keys(this.popUpUser.social_media).length
      let completeSocialMedia = 0
      Object.keys(socialMediaLinks).forEach(function (key) {
        if (socialMediaLinks[key]) {
          completeSocialMedia = completeSocialMedia + socialMediaPercentage
        }
      })

      let completeSelfBio = 0
      if (this.popUpUser.self_biography) {
        completeSelfBio = 10
      }
      let completeWebsiteBio = 0
      if (this.popUpUser.website_biography) {
        completeWebsiteBio = 10
      }
      if (completedPersonalDetails > 39) {
        this.personal_details.PersonalDetails.complete = true
      }
      if (completedPhotoVideo > 19) {
        this.personal_details.ProfilePictureVideo.complete = true
      }
      if (completeSocialMedia > 19) {
        this.personal_details.SocialMedia.complete = true
      }
      if (completeSelfBio > 9) {
        this.personal_details.WebBiography.complete = true
      }
      if (completeWebsiteBio > 9) {
        this.personal_details.SalesParticulatebio.complete = true
      }

      this.totalProgress = Math.round(completedPersonalDetails + completedPhotoVideo + completeSocialMedia + completeSelfBio + completeWebsiteBio)
    },

    setProgressBarColor () {
      if (this.totalProgress < 40) {
        this.setColor = '#ff2626'
      }
      if (this.totalProgress >= 40) {
        this.setColor = '#ffbb00'
      }
      if (this.totalProgress > 75) {
        this.setColor = '#69f542'
      }
    },
    hover () {
      let vm = this
      this.timer = setTimeout(function () {
        vm.showPopover()
      }, 600)
    },

    hoverOut () {
      let vm = this
      clearTimeout(vm.timer)
      this.timer = setTimeout(function () {
        if (!vm.isInInfo) {
          vm.closePopover()
        }
      }, 200)
    },

    hoverInfo () {
      this.isInInfo = true
    },

    hoverOutInfo () {
      this.isInInfo = false
      this.hoverOut()
    },

    showPopover () {
      this.showPopup = true
    },

    closePopover () {
      this.showPopup = false
    }
  }
}
</script>
<style lang="scss" scoped>

    .progress {
        background-color: rgb(202, 202, 202);
        border-radius: 13px;
        height: 10px;
        width: 100px;
        transition: width 500ms;
    }
    .progressbarval {
        content: '';
        display: block;
        height: 100%;
        border-radius: 9px;
    }

    .inline{
        display: inline-block;
        position: relative;
    }
    .user-popover{
        position: absolute;
        right: 120%;
        bottom: -110%;
        background: #707070;
        border: 1px solid #fff;
        color: #fff;
        z-index:1000;
    }

    .user-popover:before {
        content:"";
        position: absolute;
        height: 0px;
        width: 0px;
        bottom: 10px;
        right: -29px; /* 1px buffer for zooming problems while rendering*/
        border-width: 15px;
        border-color: transparent transparent transparent #707070;
        border-style: solid;
    }

</style>
